import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import BackChevronIconSvg from '../../../assets/icons/icon-back-chevron.svg?react';
import { BaseButton } from '../../../shared/ui';

type TipsStatementHeaderProps = {
  onBack: () => void;
};

const Header = styled.header.attrs({
  'data-ui': 'tips-statement-header',
})`
  min-height: ${({ theme }) => theme.scale.px(35)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.scale.px(24)};
`;

const BackButton = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(24)};
  height: ${({ theme }) => theme.scale.px(24)};
  display: grid;
  place-items: center;
`;

const BackChevronIcon = styled(BackChevronIconSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(12)};
  height: ${({ theme }) => theme.scale.px(20)};

  & path {
    stroke: ${({ theme }) => theme.colors.text.primary};
  }
`;

const Title = styled.h1`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(35)};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export function TipsStatementHeader({ onBack }: TipsStatementHeaderProps) {
  const { t } = useTranslation();

  return (
    <Header>
      <BackButton
        type="button"
        aria-label={t('tipsStatement.backAria')}
        onClick={onBack}
      >
        <BackChevronIcon />
      </BackButton>
      <Title>{t('tipsStatement.title')}</Title>
    </Header>
  );
}
